module.exports = __webpack_public_path__ + "0268ad268547bda9bb0d2da9d27b8bf3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-23.png
// module id = 3217
// module chunks = 0